import { Vertex2Data, Vertex2DataIn } from './types';

export const vertex2Data = (dataIn: Vertex2DataIn = {}): Vertex2Data => {
	const position: Vertex2Data = {
		x: 0,
		y: 0,
		readOnly: false,
		...dataIn
	};

	return position;
};
